// @flow
import React from 'react';
import ListModel from 'Stores/ListModel';
import EmployeeModel from 'Stores/EmployeeModel';
import { ImageBox, ImageBoxContainer } from 'Components/ImageBox';
import IconList from 'Components/IconList';

type Props = {
  employees: Array<Object>,
  deeplinkId?: number,
};

type State = {
  employees: ListModel,
};

const PLACEHOLDER = (
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="78">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M95.11 78S93 75.36 86 71.89c-11.7-5.8-27.15-7-38-7S21.66 66 10 71.56C3 74.86.9 78 .88 78H0c.1-.14 2.45-3.68 9.57-7.06C21.4 65.33 37 64.15 48 64.15s26.6 1.24 38.43 7.13C93.55 74.83 95.9 77.85 96 78zM48 56.5c-12.14 0-19.13-8.94-21.36-27.33-1.1-9 1-16.9 5.79-22.35A20.43 20.43 0 0 1 48 0a20.46 20.46 0 0 1 15.61 6.85c4.82 5.46 6.87 13.38 5.75 22.32-1.17 9.42-3.74 16.51-7.65 21.09A17.28 17.28 0 0 1 48 56.5zM48 .72a19.52 19.52 0 0 0-15 6.57c-4.69 5.3-6.68 13-5.62 21.79 1.17 9.62 3.7 16.71 7.51 21.06 3.32 3.8 7.62 5.64 13.14 5.64a16.57 16.57 0 0 0 13.17-6c3.81-4.47 6.33-11.43 7.49-20.71 1.08-8.73-.9-16.45-5.58-21.75A19.52 19.52 0 0 0 48 .72z"
    />
  </svg>
);

export default class TeamList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      employees: new ListModel(props.employees, EmployeeModel),
    };
  }

  renderEmployee = (employee: EmployeeModel): Node => {
    return (
      <ImageBox
        key={employee.id}
        title={employee.fullname()}
        description={employee.jobTitle}
        image={employee.image}
        placeholder={PLACEHOLDER}
        roundImage
      >
        <IconList
          items={[
            {
              icon: 'phone',
              label: employee.phone,
              link: 'tel:' + employee.phone.replace(/[^0-9.]+/g, ''),
            },
            { icon: 'mail', label: employee.email, link: 'mailto:' + employee.email },
          ]}
        />
      </ImageBox>
    );
  };

  renderDepartment = (group: { key: string, items: ListModel }) => {
    const department = EmployeeModel.getLabelByValue(EmployeeModel.departments, group.key);

    const sortindex = group.items.getItemByIndex(0).sortIndex;

    if (sortindex && sortindex > 0) {
      group.items.sortByProp('sortIndex');
    }

    return (
      <ImageBoxContainer headline={department} key={group.key} fixed>
        {group.items.map((employee) => this.renderEmployee(employee))}
      </ImageBoxContainer>
    );
  };

  renderContent = (groupedEmployees: Object[]) => {
    if (groupedEmployees.length) {
      return (
        <div id={this.props.deeplinkId}>
          {groupedEmployees.map((department) => this.renderDepartment(department))}
        </div>
      );
    }

    return '';
  };

  render() {
    const groupedEmployees = this.state.employees
      .sortByProp('lastname')
      .groupBy('department', EmployeeModel.departmentSorting);

    return this.renderContent(groupedEmployees);
  }
}
